import React from "react";
import PropTypes from "prop-types";
import { Header, Icon, Segment } from "semantic-ui-react";

const HomepageStatsBasicItem = ({ icon, value, label }) => {
  return (
    <Segment
      style={{ height: "100%" }}
      textAlign="center"
      className="homepage-stats-item"
      padded
    >
      <Icon
        name={icon}
        size="huge"
        color="blue"
        style={{ marginBottom: "0.5em" }}
      />
      <Header as="h2" style={{ margin: 0 }}>
        {value}
      </Header>
      <p style={{ margin: 0 }}>{label}</p>
    </Segment>
  );
};

HomepageStatsBasicItem.propTypes = {
  icon: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
};

export default HomepageStatsBasicItem;
